import { render, staticRenderFns } from "./registrationManagement.vue?vue&type=template&id=6429605c&scoped=true&"
import script from "./registrationManagement.vue?vue&type=script&lang=js&"
export * from "./registrationManagement.vue?vue&type=script&lang=js&"
import style0 from "./registrationManagement.vue?vue&type=style&index=0&id=6429605c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6429605c",
  null
  
)

export default component.exports